module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_j_leucistic.325379e0.png";